import { motion } from "framer-motion";
import Testimonials from "../components/Testimonials";

export default function TestimonialsPage() {
  return (
    <div data-testid="testimonials-page" className="pt-20">
      {/* FEATURED COACH QUOTE — Colby Swanson */}
      <section data-testid="featured-coach-quote" className="pt-14 md:pt-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
            className="grid grid-cols-12 gap-x-0 gap-y-8 md:gap-14 items-center"
          >
            <div className="col-span-12 md:col-span-5 order-2 md:order-1">
              <div className="relative overflow-hidden border border-foreground/15 bg-foreground max-w-sm md:max-w-none mx-auto md:mx-0" data-testid="featured-coach-image">
                <img
                  src="https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/wjquzujm_COLBY%20SWANSON.jpeg"
                  alt="Instagram story from Colby Swanson (coachcvswan), Blue Earth Area Head Coach, endorsing Isaac Fink and BeGreat Basketball Training"
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-span-12 md:col-span-7 order-1 md:order-2 relative">
              <div className="absolute -top-6 md:-top-12 left-0 font-display text-8xl md:text-[10rem] leading-none text-primary/25 select-none pointer-events-none">"</div>
              <div className="flex items-center gap-3 mb-5 relative">
                <span className="h-px w-10 bg-primary" />
                <span className="text-xs font-bold uppercase tracking-[0.3em] text-primary">Head Coach Endorsement</span>
              </div>
              <blockquote className="font-display uppercase text-3xl sm:text-4xl md:text-5xl leading-[1.02] tracking-tight relative">
                "I've seen a lot of player development coaches at work — NBA guys included — <span className="text-primary">Isaac is Tier 1.</span>"
              </blockquote>
              <figcaption className="mt-8 flex flex-col gap-1">
                <span className="font-display uppercase text-xl md:text-2xl leading-none">— Colby Swanson</span>
                <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-foreground/60">Blue Earth Area · Head Coach</span>
              </figcaption>
            </div>
          </motion.div>
        </div>
      </section>

      <Testimonials />
    </div>
  );
}
